import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { Box, Button } from '@mui/material'
import esocialImage from 'assets/brazil-stamp.svg'
import govImage from 'assets/gov.svg'
import receitaFederalImage from 'assets/receita-federal.svg'
import ImageBanner from 'components/image-banner'
import LogoTheme from 'components/logo-theme'
import SecuritySVG from 'components/svg/security'
import WrapperPermission from 'components/wrapper-permission'
import { useAuth } from 'contexts/auth'
import { useCustomTheme } from 'contexts/theme'
import { useHistory } from 'react-router-dom'
import OrganizationInfo from '../organization-info'
import { useStyles } from './styles'

const DatasourceConnect = () => {
  const { skipUploadCertificate, updateUserData } = useAuth()
  const { theme } = useCustomTheme()
  const classes = useStyles()
  const history = useHistory()
  const { user } = useAuth()

  const handleSkipUpload = async () => {
    skipUploadCertificate()
    // Atualiza os dados do usuário antes de redirecionar para garantir que emailIsConfirmed está correto
    await updateUserData()
    await history.push('/redirect')
  }

  const connectionBox = (href: string, label: string, image: string, disabled?: boolean) => {
    return (
      <Box
        className={classes.connectionBox}
        display='flex'
        alignItems='center'
        justifyContent='space-between'
        marginBottom='16px'
      >
        <Box
          display='flex'
          gap={1}
        >
          <img
            src={image}
            alt='esocial-image'
            style={{ opacity: disabled ? '0.2' : '1' }}
          />
          <p style={{ fontWeight: 'bold', opacity: disabled ? '0.2' : '1' }}>{label}</p>
        </Box>

        <Button
          variant='text'
          size='large'
          disabled={disabled}
          onClick={() => history.push(href)}
          sx={{ height: '48px' }}
        >
          Conectar
          <KeyboardArrowRightIcon
            color={disabled ? 'disabled' : 'primary'}
            sx={{ ml: 2 }}
          />
        </Button>
      </Box>
    )
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <LogoTheme />
            <h1 className={classes.formTitle}>Conexões</h1>
            <span className={classes.formSubTitle}>
              Organize suas fontes de dados escolhendo apenas as que deseja armazenar de maneira simples e eficiente.
            </span>

            <OrganizationInfo
              organizationName={user!.organization?.name as string}
              organizationFederalTaxId={user!.organization?.cnpj as string}
            />

            <Box
              display='flex'
              flexDirection='column'
              marginTop='16px'
            >
              {connectionBox('/request-permission', 'eSocial', esocialImage)}
              {/* {connectionBox('/esocial-connect', 'eSocial', esocialImage)} */}
              {connectionBox('/certificate-upload', 'gov.br', govImage, true)}
              {connectionBox('/certificate-upload', 'Receita Federal', receitaFederalImage, true)}
            </Box>

            <p className={classes.textFoot}>
              Atenção: neste momento, apenas você tem acesso aos seus dados, e eles não são visíveis para a{' '}
              <b>Conducco</b>. Eles só serão compartilhados após o seu consentimento na próxima etapa.
            </p>

            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              width='100%'
            >
              <Button
                color='inherit'
                variant='outlined'
                onClick={async () => await handleSkipUpload()}
                // onClick={() => history.push('/request-permission')}
                // onClick={() => history.push('/')}
                sx={{
                  borderColor: '#000000 !important',
                  color: '#000000 !important',
                  height: '42px',
                  padding: '0 2rem',
                }}
              >
                Pular esta etapa
              </Button>
              {/* <div /> */}

              <Button
                variant='contained'
                onClick={() => history.push('/invite-responsible')}
                color='inherit'
                sx={{
                  backgroundColor: '#31F7FF !important',
                  color: '#000000 !important',
                  height: '42px',
                  padding: '0 2rem',
                }}
              >
                Convidar responsável
              </Button>
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='Bem-vindo à Conducco. Vamos começar a configurar o seu Cofre Digital.'
          banner={<SecuritySVG />}
        />
      </Box>
    </Box>
  )
}

export default DatasourceConnect
